import React from 'react';
import Chart from 'react-apexcharts';
import { Category } from '../../types/Lessons';
import { Box } from '@mui/material';

const HeatmapChart = (props: { categories: Category[], field: string }) => {
  const series = props.categories.map(category => { 
    return { name: category.name, data: category.severities[props.field].map((amount, score) => {
      return { x: `${score}`, y: amount }
    }) }
  })

  const options = {
    chart: {
      toolbar: { show: false }
    },
    dataLabels: {
      enabled: false
    },
    legend: {
      show: false
    },
    zoom: {
      enabled: false,
      allowMouseWheelZoom: false
    },
    selection: {
      enabled: false
    },
    colors: ['#6b66ff'],
    xaxis: {
      title: { 
        text: '',
      },
      labels: {
        style: {
          fontFamily: 'var(--header-font)',
        },
        formatter: function (val: number) {
          const labels = {
            '0': "Low",
            '1': "Medium",
            '2': "High"
          };
          return labels[val] || val;
        }
      },
      axisBorder: {
        show: false,
        color: "var(--color-greyDark)"
      },
      tickAmount: 2,
      min: 1,
      max: 3
    },
    yaxis: {
      title: { 
        text: '',
        style: {
          fontFamily: 'var(--header-font)',
          fontWeight: 500,
          fontSize: 12
        } 
      },
      labels: {
        style: {
          fontFamily: 'var(--header-font)',
        }
      },
      axisBorder: {
        show: false,
        color: "var(--color-greyDark)"
      },
      tickAmount: 4,
      min: 1,
      max: 5
    },
    grid: {
      yaxis: {
        lines: {
          show: false
        }
      }
    },
    tooltip: {
      enabled: false
    }
  };

  return <Box style={{ pointerEvents: 'none' }}><Chart options={options} series={series} type="heatmap" height={350} /></Box>
};

export default HeatmapChart;